import React from 'react';

const OrdersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
  <path d="M0 0H16V1.83333H0V0ZM0 4.58333H16V6.41667H0V4.58333ZM0 9.16667H16V11H0V9.16667Z" fill="currentColor"/>
</svg>
);

export default OrdersIcon;